import { SiShopify, SiGoogleads, SiMeta, SiMailchimp, SiStripe, SiTiktok, SiNike, SiSamsung, SiNetflix, SiAirbnb, SiSpotify, SiGoogleanalytics, SiHubspot, SiSony } from "react-icons/si";

const logos = [
  { Icon: SiShopify, name: "Shopify" },
  { Icon: SiGoogleads, name: "Google Ads" },
  { Icon: SiMeta, name: "Meta" },
  { Icon: SiMailchimp, name: "Mailchimp" },
  { Icon: SiStripe, name: "Stripe" },
  { Icon: SiTiktok, name: "TikTok" },
  { Icon: SiHubspot, name: "Hubspot" },
  { Icon: SiNike, name: "Nike" },
  { Icon: SiSony, name: "Sony" },
  { Icon: SiSamsung, name: "Samsung" },
  { Icon: SiNetflix, name: "Netflix" },
  { Icon: SiAirbnb, name: "Airbnb" },
  { Icon: SiSpotify, name: "Spotify" },
  { Icon: SiGoogleanalytics, name: "GA4" },
];

export default function TrustedBrands() {
  return (
    <section data-testid="trusted-brands-section" className="relative py-20 border-y border-white/5 bg-[#070709]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">
            Trusted Globally • USA · UK · EU · UAE · AUS
          </span>
          <p className="mt-3 font-display text-2xl md:text-3xl font-bold text-white">
            Powering eCommerce growth for premium brands worldwide
          </p>
        </div>
        <div className="relative overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#070709] to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#070709] to-transparent z-10" />
          <div className="flex gap-16 marquee w-max">
            {[...logos, ...logos].map(({ Icon, name }, i) => (
              <div
                key={i}
                className="flex items-center gap-3 text-zinc-500 hover:text-white transition shrink-0"
                data-testid={`brand-logo-${name.toLowerCase().replace(/\s/g, "-")}`}
              >
                <Icon className="h-7 w-7" />
                <span className="font-display text-lg font-bold tracking-tight">{name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
